import { NavItem } from '@shared/navbar/navbar.component';
import { Route } from './route';
import DATA_QA from '@automation/data-qa.json';

export const NavbarTabsData = [
    new NavItem(
        Route.Inbox,
        'Workflow Inbox',
        'document',
        false,
        undefined,
        `/${Route.Inbox}`,
        DATA_QA.navbarItemInbox,
    ),
    new NavItem(
        Route.StationInbox,
        'Station Inbox',
        'message',
        false,
        undefined,
        `/${Route.StationInbox}`,
        DATA_QA.navbarItemStationInbox,
    ),
    new NavItem(
        Route.Configuration,
        'Configuration',
        'administration',
        false,
        undefined,
        `/${Route.Configuration}`,
        DATA_QA.navbarItemConfiguration,
    ),
];
